import type { IPaginatedResponse, IAct } from '@newo/api/gateway';

type PaginatedActs = IPaginatedResponse<IAct>[];

export const getActs = (pages: PaginatedActs = []) => {
    return pages.flatMap((page) => page.items).reverse();
};
